import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// shared components
import ModalWrapper from 'components/shared/ModalWrapper'
import Markdown from 'components/shared/Markdown'
import RoomMeetingSchedule from 'components/virtual/shared/RoomMeetingSchedule'

// local components
import Actions from './Actions'

const RoomDetailsModal = props => {
  const {
    actions, // via parent
    roomMeeting, // via parent
    liveNow // via RoomMeetingCardContainer/withState
  } = props

  const { room } = roomMeeting
  const { summary, details, thumbnailUrl } = room

  const modalId = `room-meeting-${roomMeeting.id}`

  return (
    <ModalWrapper modalId={modalId} closeButton>
      <Box
        component='img'
        src={thumbnailUrl}
        sx={{
          display: 'block',
          mb: 4,
          mx: 'auto',
          maxWidth: '100%',
          maxHeight: { xs: '200px', sm: '240px' }
        }}
      />

      <Typography my={1} variant='h3' align='center'>
        {room.title}
      </Typography>

      <Box align='center' mb={1}>
        <RoomMeetingSchedule
          key={roomMeeting.id}
          variant='body1'
          roomMeeting={roomMeeting}
          liveNow={liveNow}
        />
      </Box>

      {actions && <Actions {...props} />}

      <Typography mt={4} variant='body1'>
        {summary}
      </Typography>

      {details && (
        <Box my={2}>
          <Markdown>{details}</Markdown>
        </Box>
      )}
    </ModalWrapper>
  )
}

export default RoomDetailsModal
